import React, { useState } from 'react';
import { SectionHeader } from './SectionHeader';
import { ChevronDown, Book } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const tomos = [{
  num: 1,
  color: 'bg-peach',
  title: 'Mentalidad de aprobación',
  subtitle: 'Cómo preparar tu cabeza antes de abrir el primer apunte',
  bullets: ['Por qué el miedo te hace estudiar peor y cómo salir del loop', 'Diagnóstico de 10 minutos: tiempo real, materias reales, prioridades reales', 'Tu mapa de ruta para esta semana listo en una página']
}, {
  num: 2,
  color: 'bg-salmon',
  title: 'Técnicas de estudio bajo presión',
  subtitle: 'Las herramientas concretas para aprender más en menos tiempo',
  bullets: ['Lectura activa, método pregunta-respuesta y mapas mentales exprés', 'Pomodoro ajustado a parciales: los bloques que sí funcionan', 'Cómo identificar qué estudiar primero y qué podés saltear']
}, {
  num: 3,
  color: 'bg-sun',
  title: 'Gestión del estrés en exámenes',
  subtitle: 'Aprender a rendir con la presión encima, no a pesar de ella',
  bullets: ['Técnicas de respiración para bajar la ansiedad en minutos', 'Cómo dormir cuando la cabeza no para', 'Rutinas cortas que estabilizan el estado de ánimo en días de estudio']
}, {
  num: 4,
  color: 'bg-palegreen',
  title: 'Memoria y retención acelerada',
  subtitle: 'Cómo hacer que lo que estudiás se quede aunque el tiempo no alcance',
  bullets: ['Repetición espaciada: el sistema más efectivo respaldado por la ciencia', 'Técnica Feynman y mnemotecnia práctica', 'Tu plan de repaso de los últimos 3 días']
}, {
  num: 5,
  color: 'bg-lightblue',
  title: 'El día del examen',
  subtitle: 'De que te levantás a que salís del aula',
  bullets: ['Rutina de la mañana del examen paso a paso', 'Cómo arrancar aunque no sepas por dónde empezar', 'Protocolo de desbloqueo mental para usar dentro del aula']
}, {
  num: 6,
  color: 'bg-lavender',
  title: 'Concentración y productividad',
  subtitle: 'Estudiar menos horas pero que rindan el doble',
  bullets: ['Cómo eliminar distracciones reales del entorno físico y digital', 'Estado de flujo: cómo entrás y cómo lo sostenés', 'Tu protocolo personal de concentración']
}];
export function Tomos() {
  const [openId, setOpenId] = useState<number | null>(null);
  return <section className="py-20 px-6 lg:px-8 bg-cream" data-id="element-243">
      <div className="max-w-[800px] mx-auto" data-id="element-244">
        <SectionHeader data-id="element-245" />
        <div className="text-center mb-12" data-id="element-246">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-247">
            LOS 6 TOMOS DEL PACK ESENCIAL
          </h2>
          <p className="text-xl text-dark/70 font-medium mb-4" data-id="element-248">
            Tu hoja de ruta completa para aprobar
          </p>
          <p className="text-sm font-bold text-salmon bg-white inline-block px-4 py-2 rounded-full border border-border shadow-sm" data-id="element-249">
            Tocá cada tomo para ver qué incluye 👆
          </p>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-250">
          {tomos.map(tomo => <div key={tomo.num} className={`bg-white rounded-xl md:rounded-2xl border transition-all duration-300 overflow-hidden ${openId === tomo.num ? 'border-salmon shadow-md' : 'border-border shadow-sm hover:border-salmon/50'}`} data-id="element-251">
              <button onClick={() => setOpenId(openId === tomo.num ? null : tomo.num)} className="w-full text-left px-4 py-3 md:px-6 md:py-5 flex items-center justify-between focus:outline-none group" data-id="element-252">
                <div className="flex items-center gap-3 md:gap-4" data-id="element-253">
                  <div className={`w-8 h-8 md:w-12 md:h-12 rounded-lg md:rounded-xl flex items-center justify-center font-bold text-sm md:text-lg transition-colors ${openId === tomo.num ? `${tomo.color} text-dark` : 'bg-cream text-dark/60 group-hover:bg-border/60'}`} data-id="element-254">
                    {tomo.num}
                  </div>
                  <div data-id="element-255">
                    <p className="text-[10px] md:text-xs font-bold text-dark/50 uppercase tracking-wider mb-0.5 md:mb-1" data-id="element-256">
                      TOMO {tomo.num}
                    </p>
                    <h3 className="font-bold text-sm md:text-lg lg:text-xl leading-tight" data-id="element-257">
                      {tomo.title}
                    </h3>
                  </div>
                </div>
                <motion.div animate={{
              rotate: openId === tomo.num ? 180 : 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-258">
                  <ChevronDown className={`shrink-0 ${openId === tomo.num ? 'text-salmon' : 'text-dark/40'}`} size={20} data-id="element-259" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-260">
                {openId === tomo.num && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-261">
                    <div className="px-4 pb-4 pt-1 md:px-6 md:pb-6 md:pt-2 border-t border-border/50" data-id="element-262">
                      <p className="font-medium text-dark/80 mb-3 md:mb-4 italic text-xs md:text-base" data-id="element-263">
                        "{tomo.subtitle}"
                      </p>
                      <ul className="space-y-2 md:space-y-3" data-id="element-264">
                        {tomo.bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-2 md:gap-3 text-xs md:text-base" data-id="element-265">
                            <Book size={16} className="text-salmon shrink-0 mt-0.5 md:mt-1" data-id="element-266" />
                            <span className="text-dark/80" data-id="element-267">{bullet}</span>
                          </li>)}
                      </ul>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}